import { render } from "./Banner.vue?vue&type=template&id=1cea211b&scoped=true&ts=true"
import script from "./Banner.vue?vue&type=script&lang=ts"
export * from "./Banner.vue?vue&type=script&lang=ts"

import "./Banner.vue?vue&type=style&index=0&id=1cea211b&lang=postcss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cea211b"]])

export default __exports__